import React from 'react'

import FormCheckbox from '@f/elements/FormCheckbox'

const FilterCheckbox = props => {
  const handleCheckbox = () => {
    const target = event.target
    let params = { ...props.params }

    if (Object.keys(params).find(el => el.indexOf(`${target.name}__in`) > -1)) {
      let currentValues = params[`${target.name}__in`].split(',')
      if (target.checked) {
        currentValues.push(target.value)
        params[`${target.name}__in`] = currentValues.join(',')
      } else {
        currentValues = currentValues.filter(
          val => val !== target.value && !!val
        )
        params[`${target.name}__in`] = currentValues.join(',')
      }
    } else {
      if (target.checked) {
        params[`${target.name}__in`] = target.value
      }
    }

    const { lat__range, lon_range, ...paramsWithoutLocation } = params
    props.updateQuery(paramsWithoutLocation)
  }

  return (
    <FormCheckbox
      label={props.option.name}
      theme='form'
      labelClassNames='[ f-t-body f-c-fo-pri ]'
      className='[ f-d-bl f-m-b-010 ]'
      onChange={handleCheckbox}
      checkboxValue={props.option.id}
      name={props.filter.name}
      checked={
        !!(
          props.params[`${props.filter.name}__in`] &&
          props.params[`${props.filter.name}__in`]
            .split(',')
            .indexOf(props.option.id.toString()) > -1
        )
      }
      wtData={{
        checkbox: {
          label: props.option.name,
          location: 'filter-panel'
        }
      }}
    />
  )
}

export default FilterCheckbox
